export default __webpack_public_path__ + "static/media/31.fd0f5989.jpg";